import { IdvMediator, ControllerType } from '@ondato/iframe-mediator'
import { apiProxyMethods } from '@src/scripts/enums'
import Api, { get } from '@src/scripts/api'

export const apiProxyHandlers = {
  data() {
    return {
      apiProxyController: null
    }
  },

  beforeDestroy() {
    if (this.apiProxyController) {
      this.apiProxyController.unregisterHandlers()
      this.apiProxyController = null
    }
  },

  methods: {
    loadApiProxyHandlers(target) {
      if (!target) {
        return
      }

      const eventHandler = new IdvMediator({
        type: ControllerType.Parent,
        iframeElement: target,
        allowedOrigin: BaseUrl.resources
      })

      eventHandler.registerHandler(
        apiProxyMethods.getPdfSignatureStatus,
        this.handleGetPdfSignatureStatus
      )

      this.apiProxyController = eventHandler
    },

    async handleGetPdfSignatureStatus() {
      const { data, error } = await get(Api.pdfSignatureStatus)
      if (error) {
        this.$popUp('Failed')
        throw new Error('Failed')
      }

      return data
    }
  }
}
